import React from 'react';
import './category.css';
import useWeddingCategories from '../../Hooks/weddingCategories';

const WeadingCategory = () => {
  const weddingCategories = useWeddingCategories();

  return (
    <div className="wedding-collection-section">
      <div className="collection-header">
        <h2 className="collection-title">The Wedding Collection</h2>
        <p className="collection-subtitle">From Haldi to Honeymoon</p>
      </div>
      
      <div className="wedding-categories-grid">
        {weddingCategories.map((category, index) => (
          <div key={category.id} className="wedding-category-card">
            <div className="category-image-container">
              <img 
                src={category.image} 
                alt={category.name}
                className="category-image"
                loading={index < 3 ? "eager" : "lazy"}
                decoding="async"
                fetchPriority={index < 2 ? "high" : "auto"}
                onError={(e) => {
                  e.target.style.display = 'none';
                  e.target.nextSibling.style.display = 'flex';
                }}
              />
              <div 
                className="image-placeholder" 
                style={{
                  display: 'none',
                  background: category.gradient
                }}
              >
                <span className="category-icon">{category.icon}</span>
                <span className="category-name">{category.name}</span>
              </div>
            </div>
            <h3 className="category-title">{category.name}</h3>
          </div>
        ))}
      </div>
    </div>
  );
};

export default WeadingCategory;